import { filter } from 'rxjs/operators';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any, moment: any

@Component({
  selector: 'app-case',
  templateUrl: './case.component.html',
  styleUrls: ['./case.component.scss']
})
export class CaseComponent implements OnInit {

  followCaseList: any = []
  myCaseList: any = []

  
  tmpFollowCaseList: any = []
  tmpMyCaseList: any = []

  isCheckedAll = false
  selectList: any

  myCaseHigh = 0
  myCaseMedium = 0
  myCaseLow = 0

  followCaseHigh = 0
  followCaseMedium = 0
  followCaseLow = 0

  caseStatusList: any

  caseTypeList: any
  subTypeTmpList: any

  caseSubTypeMyList: any = []
  caseSubTypeFollowList: any = []

  subTypeDetailTmpList: any

  caseSubTypeDetailMyList: any = []
  caseSubTypeDetailFollowList: any = []

  caseNoMy: string = ""
  firstnameMy: string = ""
  lastnameMy: string = ""
  telephoneMy: string = ""
  caseTypeMy: string = ""
  caseSubTypeMy: string = ""
  subTypeDetailMy: string = ""
  statusMy: string = ""

  caseNoFollow: string = ""
  firstnameFollow: string = ""
  lastnameFollow: string = ""
  telephoneFollow: string = ""
  caseTypeFollow: string = ""
  caseSubTypeFollow: string = ""
  subTypeDetailFollow: string = ""
  statusFollow: string = ""

  forwardTeam: any

  dtMy: any = null
  dtFollow: any = null

  agentList: any = []
  userIdReceive = ""
  userList: any = []
  forwardRemark = ""
  submittedForward = false

  cancelRemark = ""
  submittedCancel = false

  role: any = {}
  myTeams: any
  teamList: any

  cookieData: any
  // @ViewChildren('tbMy') tbMy: QueryList<any>;
  // @ViewChildren('tbFollow') tbFollow: QueryList<any>;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private util: UtilService
  ) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)
    this.util.InitValidation()
    let thisTs = this

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.myTeams = JSON.parse(this.cookieData.teams)

    this.callApi()
    //await this.initDropdown()
    //await this.getCase()

    $(".select2").select2();
    $("#userIdReceive").on("change", function () {
      thisTs.userIdReceive = $("#userIdReceive").find('option:selected').val()
    })

    $('#dateFromMy').on('changeDate', function (ev: any) {
      $('#dateToMy').datepicker('setStartDate', ev.date);
    });
    $('#dateToMy').on('changeDate', function (ev: any) {
      $('#dateFromMy').datepicker('setEndDate', ev.date);
    });
    $('#dateFromFollow').on('changeDate', function (ev: any) {
      $('#dateToFollow').datepicker('setStartDate', ev.date);
    });
    $('#dateToFollow').on('changeDate', function (ev: any) {
      $('#dateFromFollow').datepicker('setEndDate', ev.date);
    });

  }

  callApi() {
    let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
    let myPara = ""
    let followPara = ""

    if (this.role.dpa_list_mycase) {
      myPara = "case_date_from=" + tmpDate
    }
    if (this.role.dpa_list_followcase) {
      followPara = "case_date_from=" + tmpDate
    }

    Observable.forkJoin(
      this.apiService.get("master", "caseStatus"),
      this.apiService.get("master", "caseType"),
      this.apiService.get("master", "caseSubType"),
      this.apiService.get("master", "caseSubTypeDetail"),
      this.apiService.get("master", "callcenterTeam"),
      this.apiService.get("crmservice", "caseIncident", myPara),
      this.apiService.get("crmservice", "caseIncident", followPara)
    ).subscribe(
      async data => {
        this.caseStatusList = data[0]
        this.caseTypeList = data[1]
        this.subTypeTmpList = data[2]
        this.subTypeDetailTmpList = data[3]
        this.teamList = data[4]
        this.tmpMyCaseList = data[5]
        this.tmpFollowCaseList = data[6]

        let para = ""
        this.teamList.forEach((t: any) => {
          if (para != "") {
            para += "&"
          }
          para += "callcenterteam=" + t.dpa_callcenterteamid
        });

        this.agentList = await this.apiService.get("crmservice", "callcenterProfile", para)
        this.BindCase()
        this.util.ShowWaiting(false)
      },
      err => {
        console.error(err)
        this.util.ShowWaiting(false)
      }
    );

  }

  async initDropdown() {
    this.teamList = await this.apiService.get("master", "callcenterTeam")
    // this.teamList = teams.filter((t: any) => {
    //   return this.myTeams.map((mt: any) => { return mt.dpa_callcenterteamid }).indexOf(t.dpa_callcenterteamid) > -1
    // })

    let para = ""
      this.teamList.forEach((t: any) => {
        if(para != ""){
          para += "&"
        }     
        para += "callcenterteam=" + t.dpa_callcenterteamid
      });

    this.caseStatusList = await this.apiService.get("master", "caseStatus")
    this.caseTypeList = await this.apiService.get("master", "caseType")
    this.subTypeTmpList = await this.apiService.get("master", "caseSubType")
    this.subTypeDetailTmpList = await this.apiService.get("master", "caseSubTypeDetail")

    
    this.util.ShowWaiting(false)
  }

  async BindCase() {
    this.myCaseHigh = this.myCaseMedium = this.myCaseLow = 0
    this.followCaseHigh = this.followCaseMedium = this.followCaseLow = 0

    if (!this.role.dpa_list_mycase && !this.role.dpa_list_followcase) {
      this.followCaseList = []
      this.myCaseList = []
    }
    else {
      this.tmpMyCaseList.forEach((c: any) => {
        if (c.dpa_caseowner == this.cookieData.dpa_name && c.dpa_casestatuscode != "04" && c.dpa_casestatuscode != "03") {
          this.myCaseList.push(c)
          if (c.dpa_caseseverityidname != null) {
            if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
              this.myCaseHigh++
            }
            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
              this.myCaseMedium++
            }
            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
              this.myCaseLow++
            }
          }
        }
      });

      for(var i = 0; i < this.myCaseList.length; i++)
      {
        let order;let orderpri
        if(this.myCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
        {
          order = 1;
        }
        else if(this.myCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
        {
          order = 2;
        }
        else if(this.myCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
        {
          order = 3;
        }
        else if(this.myCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
        {
          order = 4;
        }
        else if(this.myCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
        {
          order = 5;
        }
        else
        {
          order = 6;
        }
  
        if (this.myCaseList[i].dpa_caseseverityidname != null)  
        {
          if (this.myCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            orderpri = 1;
          }
          else if (this.myCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            orderpri = 2;
          }
          else if (this.myCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            orderpri = 3;
          } 
          else {
            orderpri = 4;
          }
        }
        else 
        {
          orderpri = 4;
        }
    
  
        this.myCaseList[i].ordercase = order ;
        this.myCaseList[i].orderpri = orderpri ;
  
      }
     // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
  
  
     try
     {
      /*
      tmp.sort(
        (firstObject: any, secondObject: any) =>
          (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
            (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
              (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                (firstObject.orderpri == secondObject.orderpri ) ? (
                  (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                    (new Date(firstObject.createdon.substring(0, 10))== new Date(secondObject.createdon.substring(0, 10))) ? ( 
                          (firstObject.ordercase  < secondObject.ordercase ) ? 1 : 
                  -1 )
                  :-1
                -1 )
                :-1
            -1 )
          : -1
        );  
        */
       
        this.myCaseList.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime() 
              || firstObject.orderpri - secondObject.orderpri
              || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
              || firstObject.ordercase - secondObject.ordercase  
              ));
      }
      catch
      {
  
      }


      this.tmpFollowCaseList.forEach((c: any) => {
        if (c.dpa_assignby == this.cookieData.dpa_name && c.dpa_caseowner != this.cookieData.dpa_name && c.dpa_casestatuscode != "03") {
          this.followCaseList.push(c)
          if (c.dpa_caseseverityidname != null) {
            if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
              this.followCaseHigh++
            }
            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
              this.followCaseMedium++
            }
            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
              this.followCaseLow++
            }
          }
        }
      });
    }


    for(var i = 0; i < this.followCaseList.length; i++)
    {
      let order;let orderpri
      if(this.followCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(this.followCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(this.followCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(this.followCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(this.followCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (this.followCaseList[i].dpa_caseseverityidname != null)  
      {
        if (this.followCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (this.followCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (this.followCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      this.followCaseList[i].ordercase = order ;
      this.followCaseList[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


   try
   {
    /*
    tmp.sort(
      (firstObject: any, secondObject: any) =>
        (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
          (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
            (firstObject.orderpri < secondObject.orderpri ) ? 1 :
              (firstObject.orderpri == secondObject.orderpri ) ? (
                (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                  (new Date(firstObject.createdon.substring(0, 10))== new Date(secondObject.createdon.substring(0, 10))) ? ( 
                        (firstObject.ordercase  < secondObject.ordercase ) ? 1 : 
                -1 )
                :-1
              -1 )
              :-1
          -1 )
        : -1
      );  
      */
     
      this.followCaseList.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime() 
            || firstObject.orderpri - secondObject.orderpri
            || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
            || firstObject.ordercase - secondObject.ordercase  
            ));
    }
    catch
    {
      
    }


    this.drawTableMyCase()
    this.drawTableFollowCase()
  }

  clearActionActive() {
    $(".action-menu").each(function () {
      $(this).removeClass("active")
    })
  }

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
    this.clearActionActive()
  }

  newCase(event: any) {
    const url = this.util.baseUrl() + `/newCase/`
    window.open(url, '_blank');
  }
  delete(event: any) {
    this.getSelectedContact()
    if (this.selectList.length < 1) {
      this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
    }
    else {
      this.clearActionActive()
      event.target.classList.add("active")
      $("#deleteModal").modal('show')
    }
  }

  async forward(event: any) {
    this.getSelectedContact()
    if (this.selectList.length != 1) {
      this.util.WarningDialog("กรุณาเลือก case 1 รายการ");
    }
    else {
      if (this.selectList[0].status.toLowerCase() != "new" && this.selectList[0].status.toLowerCase() != "inprogress") {
        this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น")
        return
      }

      try {
        let caseForward: any = this.myCaseList.filter((c: any) => {
          return c.incidentid == this.selectList[0].caseId
        })

        let caseForwardSubTypeDetail: any = this.subTypeDetailTmpList.filter((st: any) => {
          return st.dpa_casesubtypedetailid == caseForward[0].dpa_casesubtypedetailid
        })

        let matchTeam: any = this.teamList.filter((t: any) => {
          return t.dpa_callcenterteamid == caseForwardSubTypeDetail[0].dpa_teamownerid
        })
        if (matchTeam != null && matchTeam.length > 0) {
          this.forwardTeam = caseForwardSubTypeDetail[0].dpa_teamownerid
          await this.onForwardTeamChange()

          let matchUser: any = this.userList.filter((u: any) => {
            return u.dpa_customwebuserid == caseForwardSubTypeDetail[0].dpa_caseownerid
          })
          if (matchUser != null && matchUser.length > 0) {
            this.userIdReceive = caseForwardSubTypeDetail[0].dpa_caseownerid
          }
          else{
            this.userIdReceive = ""
          }
        }
        else{
          this.forwardTeam = ""
        }

      }
      catch (e) {
        console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้")
        this.forwardTeam = ""
        await this.onForwardTeamChange()
        this.userIdReceive = ""

      }

      this.clearActionActive()
      event.target.classList.add("active")
      this.submittedForward = false
      this.forwardRemark = ""
      $("#forwardModal").modal('show')
    }
  }

  async confirmForward() {
    this.submittedForward = true
    let success = 0, fail = 0

    if (this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "") {
      this.util.ShowWaiting(true)

      for (let i = 0; i < this.selectList.length; i++) {
        let caseId: any = this.selectList[i].caseId

        let req: any = this.myCaseList.filter((c: any) => {
          return c.incidentid == caseId
        })

        req[0].customerid = this.selectList[i].customerId
        req[0].dpa_modifiedby = this.cookieData.userId
        req[0].dpa_owningteamid = this.forwardTeam
        req[0].dpa_caseowner = this.userIdReceive
        req[0].dpa_assignby = this.cookieData.userId
        req[0].dpa_remark = this.forwardRemark

        var res = await this.apiService.put("crmservice", "caseIncident-share/" + caseId, req[0]);
        if (this.util.isSuccessResponse(res)) {
          ++success
        } else {
          ++fail
        }
      }

      //some case fail some case success
      if (fail > 0 && success > 0) {
        this.util.WarningDialog("ส่งต่อ Case สำเร็จจำนวน: " + success + " Case, ส่งต่อ Case ไม่สำเร็จจำนวน: " + fail + " Case")
      }
      //no case fail no case success
      else if (fail == 0 && success == 0) {
        this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ")
      }
      //fail
      else if (fail > 0 && success == 0) {
        this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ")
      }
      //success
      else {
        $("#forwardModal").modal('hide')
        this.util.SuccessDialog("ส่งต่อ Case สำเร็จ")
      }
      await this.searchMyCase(true)
      await this.searchFollowCase(true)
      this.util.ShowWaiting(false)
    }
  }

  async confirmDelete() {
    this.submittedCancel = true

    if (this.cancelRemark.trim() != "") {
      this.util.ShowWaiting(true)
      let success = 0, fail = 0

      let cancelStatus = this.caseStatusList.filter((c: any) => {
        return c.dpa_name.toLowerCase().trim() == "cancel"
      })

      if (cancelStatus == null || cancelStatus.length == 0) {
        this.util.ErrorDialog("ไม่สามารถดึงค่าสถานะยกเลิกได้ กรุณาติดต่อเจ้าหน้าที่")
        return
      }

      for (let i = 0; i < this.selectList.length; i++) {
        let caseId: any = this.selectList[i].caseId
        let req: any = this.myCaseList.filter((c: any) => {
          return c.incidentid == caseId
        })
        req[0].customerid = this.selectList[i].customerId
        req[0].dpa_modifiedby = this.cookieData.userId
        req[0].dpa_casestatusid = cancelStatus[0].dpa_casestatusid
        req[0].dpa_remark = this.cancelRemark

        var res = await this.apiService.put("crmservice", "caseIncident/" + caseId, req[0]);
        if (this.util.isSuccessResponse(res)) {
          ++success
        } else {
          ++fail
        }
      }

      //some case fail some case success
      if (fail > 0 && success > 0) {
        this.util.WarningDialog("ยกเลิก Case สำเร็จจำนวน: " + success + " Case, ยกเลิก Case ไม่สำเร็จจำนวน: " + fail + " Case")
      }
      //no case fail no case success
      else if (fail == 0 && success == 0) {
        this.util.ErrorDialog("ยกเลิก Case ไม่สำเร็จ")
      }
      //fail
      else if (fail > 0 && success == 0) {
        this.util.ErrorDialog("ยกเลิก Case ไม่สำเร็จ")
      }
      //success
      else {
        $("#deleteModal").modal('hide')
        this.util.SuccessDialog("ยกเลิก Case สำเร็จ")
      }
      await this.searchMyCase(true)
      this.util.ShowWaiting(false)
    }
  }

  onCheckAllChange() {
    $(".row-checker").prop("checked", this.isCheckedAll)
  }

  getSelectedContact() {
    let thisTs = this
    this.selectList = []
    $('.row-checker:checkbox:checked').each(function () {
      let value = {
        caseId: $(this).val(),
        customerId: $(this).prop("name"),
        status: $(this).closest('tr').find('td.status')[0].innerHTML
      }
      thisTs.selectList.push(value)
    })
  }

  async searchMyCase(getAll: boolean = false) {

    this.myCaseHigh = this.myCaseMedium = this.myCaseLow = 0
    if (!this.role.dpa_list_mycase) {
      return
    }
    //this.util.ShowWaiting(true)

    $('#tbMyCase').DataTable().clear().destroy();

    let filterd: any = []

    if (getAll) {
      let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
      filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
    }
    else {
      let para = ""


      let fromDtMy = $('#dateFromMy').val();
      let toDtMy = $('#dateToMy').val();

      if (this.caseNoMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoMy
      }
      if (this.firstnameMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameMy
      }
      if (this.lastnameMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameMy
      }
      if (this.telephoneMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneMy
      }

      if (this.caseTypeMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeMy
      }
      if (this.caseSubTypeMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeMy
      }
      if (this.subTypeDetailMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailMy
      }
      if (this.statusMy.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusMy
      }


      if (fromDtMy != null && fromDtMy != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtMy, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (toDtMy != null && toDtMy != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtMy, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (para.length > 0) {
        filterd = await this.apiService.get("crmservice", "caseIncident", para)
      }
      else {
        let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
        filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
      }
    }

    let tmp: any = []
    filterd.forEach((c: any) => {
      if (c.dpa_caseowner == this.cookieData.dpa_name && c.dpa_casestatuscode != "04") {
        tmp.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.myCaseHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.myCaseMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.myCaseLow++
          }
        }
      }
    });

    for(var i = 0; i < tmp.length; i++)
    {
      let order;let orderpri
      if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (tmp[i].dpa_caseseverityidname != null)  
      {
        if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      tmp[i].ordercase = order ;
      tmp[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


   try
   {
    /*
    tmp.sort(
      (firstObject: any, secondObject: any) =>
        (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
          (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
            (firstObject.orderpri < secondObject.orderpri ) ? 1 :
              (firstObject.orderpri == secondObject.orderpri ) ? (
                (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                  (new Date(firstObject.createdon.substring(0, 10))== new Date(secondObject.createdon.substring(0, 10))) ? ( 
                        (firstObject.ordercase  < secondObject.ordercase ) ? 1 : 
                -1 )
                :-1
              -1 )
              :-1
          -1 )
        : -1
      );  
      */
     
          tmp.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime() 
            || firstObject.orderpri - secondObject.orderpri
            || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
            || firstObject.ordercase - secondObject.ordercase  
            ));
  }
    catch
    {

    }



    this.myCaseList = tmp

    this.drawTableMyCase()
    //this.util.ShowWaiting(false)
  }

  async searchFollowCase(getAll: boolean = false) {

    this.followCaseHigh = this.followCaseMedium = this.followCaseLow = 0
    if (!this.role.dpa_list_followcase) {
      return
    }
    //this.util.ShowWaiting(true)

    $('#tbFollowCase').DataTable().clear().destroy();

    let filterd: any

    if (getAll) {
      let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
      filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
    }
    else {
      let para = ""

      let fromDtFollow = $('#dateFromFollow').val();
      let toDtFollow = $('#dateToFollow').val();


      if (this.caseNoFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoFollow
      }
      if (this.firstnameFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameFollow
      }
      if (this.lastnameFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameFollow
      }
      if (this.telephoneFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneFollow
      }

      if (this.caseTypeFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeFollow
      }
      if (this.caseSubTypeFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeFollow
      }
      if (this.subTypeDetailFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailFollow
      }
      if (this.statusFollow.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusFollow
      }

      if (fromDtFollow != null && fromDtFollow != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtFollow, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (toDtFollow != null && toDtFollow != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtFollow, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (para.length > 0) {
        filterd = await this.apiService.get("crmservice", "caseIncident", para)
      }
      else {
        let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
        filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
      }
    }

    let tmp: any = []
    filterd.forEach((c: any) => {
      if (c.dpa_assignby == this.cookieData.dpa_name && c.dpa_caseowner != this.cookieData.dpa_name && c.dpa_casestatuscode != "04") {
        tmp.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.followCaseHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.followCaseMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.followCaseLow++
          }
        }
      }
    });

    for(var i = 0; i < tmp.length; i++)
    {
      let order;let orderpri
      if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (tmp[i].dpa_caseseverityidname != null)  
      {
        if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      tmp[i].ordercase = order ;
      tmp[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));

      try
      {
        /*
        tmp.sort(
          (firstObject: any, secondObject: any) =>
            (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
              (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                  (firstObject.orderpri == secondObject.orderpri ) ? (
                    (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                      (new Date(firstObject.createdon.substring(0, 10))== new Date(secondObject.createdon.substring(0, 10))) ? ( 
                            (firstObject.ordercase  < secondObject.ordercase ) ? 1 : 
                    -1 )
                    :-1
                  -1 )
                  :-1
              -1 )
            : -1
          );  
          */
         
              tmp.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime() 
                || firstObject.orderpri - secondObject.orderpri
                || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                || firstObject.ordercase - secondObject.ordercase  
                ));
      }
        catch
        {

        }

    this.followCaseList = tmp
    this.drawTableFollowCase()
    //this.util.ShowWaiting(false)
  }

  resetSearchMyCase() {
    this.caseNoMy = ""
    this.firstnameMy = ""
    this.lastnameMy = ""
    this.telephoneMy = ""

    this.caseTypeMy = ""
    this.caseSubTypeMy = ""
    this.subTypeDetailMy = ""
    this.statusMy = ""

    this.caseSubTypeMyList = []
    this.caseSubTypeDetailMyList = []

    $('#dateFromMy').val("").datepicker("update");
    $('#dateToMy').val("").datepicker("update");
  }

  resetSearchFollowCase() {
    this.caseNoFollow = ""
    this.firstnameFollow = ""
    this.lastnameFollow = ""
    this.telephoneFollow = ""

    this.caseTypeFollow = ""
    this.caseSubTypeFollow = ""
    this.subTypeDetailFollow = ""
    this.statusFollow = ""

    this.caseSubTypeFollowList = []
    this.caseSubTypeDetailFollowList = []

    $('#dateFromFollow').val("").datepicker("update");
    $('#dateToFollow').val("").datepicker("update");
  }

  // ngAfterViewInit() {
  //   this.tbMy.changes.subscribe(t => {
  //     this.initTableMy()
  //   })
  //   this.tbFollow.changes.subscribe(t => {
  //     this.initTableFollow()
  //   })
  // }

  // ngForRendred() {
  //   console.log('NgFor is Rendered');
  //   if (this.dtMy == null) {
  //     this.initTableMy()
  //   }
  //   if (this.dtFollow == null) {
  //     this.initTableFollow()
  //   }
  // }

  initTableMy() {
    let thisTs = this

    $("#tbMyCase td:not(.checkbox-col)").on("click", function () {

      let id = $(this).parent()[0].id

      const url = thisTs.util.baseUrl() + `/caseDetail/` + id
      window.open(url, '_blank');

    });
    this.dtMy = $("#tbMyCase").dataTable({
      retrieve: true,
      'searching': false,
      order: [] 
    });

  }

  initTableFollow() {
    let thisTs = this
    $("#tbFollowCase td:not(.checkbox-col)").on("click", function () {

      let id = $(this).parent()[0].id

      const url = thisTs.util.baseUrl() + `/caseDetail/` + id
      window.open(url, '_blank');
    });

    this.dtFollow = $("#tbFollowCase").dataTable({
      retrieve: true,
      order: [],
      'searching': false
    });
  }

  async onForwardTeamChange() {
    let tmp: any = await this.agentList.filter((a: any) => {
      return a.dpa_teamidlist.map((ag: any) => { return ag.dpa_callcenterteamid }).indexOf(this.forwardTeam) > -1
    })

    this.userList = []
    tmp.forEach((a: any) => {
      if(this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != this.cookieData.userId){
        this.userList.push(a)
      }
    });
  }

  onCaseTypeMyChange() {
    if (this.caseTypeMy != null && this.caseTypeMy.length > 0) {
      this.caseSubTypeMyList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.caseTypeMy)
    }
  }

  onCaseSubTypeMyChange() {
    if (this.caseSubTypeMy != null && this.caseSubTypeMy.length > 0) {
      this.caseSubTypeDetailMyList = this.subTypeDetailTmpList.filter(
        (subType: any) => subType.dpa_casesubtypeid === this.caseSubTypeMy)
    }
  }

  onCaseTypeFollowChange() {
    if (this.caseTypeFollow != null && this.caseTypeFollow.length > 0) {
      this.caseSubTypeFollowList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.caseTypeFollow)
    }
  }

  onCaseSubTypeFollowChange() {
    if (this.caseSubTypeFollow != null && this.caseSubTypeFollow.length > 0) {
      this.caseSubTypeDetailFollowList = this.subTypeDetailTmpList.filter(
        (subType: any) => subType.dpa_casesubtypeid === this.caseSubTypeFollow)
    }
  }

  drawTableMyCase() {
    $("#tbMyCase tbody").empty()
    this.myCaseList.forEach((c: any) => {
      let priority = ""
      let tr = '<tr id="' + c.ticketnumber + '">' +
        '<td align="center" class="checkbox-col">' +
        '<input type="checkbox" class="row-checker" value="' + c.incidentid + '" name="' + c.customerid + '">' +
        '</td>'


      if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
        tr += '<td align="center"></td>'
      }
      else {
        let severity = c.dpa_caseseverityidname.toLowerCase()
        if (severity == "high") {
          priority = "3"
        }
        else if (severity == "medium") {
          priority = "2"
        }
        else if (severity == "low") {
          priority = "1"
        }

        tr += '<td align="center" data-sort="' + priority + '">' +
          '<span class="dot ' + severity + '"></span>' +
          '</td>'
      }

      tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
        '<td>' + c.dpa_casesubtypeidname + '</td>' +
        '<td>' + c.customeridname + '</td>' +
        '<td>' + c.dpa_casechannelidname + '</td>' +
        '<td class="status">' + c.dpa_casestatusidname + '</td>' +
        '<td><span class="sr-only">' + this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' + 
        this.util.transformDate(c.createdon, 'shortWithTime') + '</td>'
      if (c.dpa_issla) {
        tr += '<td align="center" class="high">Over</td>'
      }
      else {
        if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
          tr += '<td align="center" class="low">Warning</td>'
        }
        else {
          tr += '<td align="center" class="high"></td>'
        }
      }
      tr += '<td><span class="sr-only">' + this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>' 
      + this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
        '</tr>'
      $("#tbMyCase tbody").append(tr);
    });

    this.initTableMy()
  }

  drawTableFollowCase() {
    $("#tbFollowCase tbody").empty()
    this.followCaseList.forEach((c: any) => {
      let priority = ""
      let tr = ""

      if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
        tr += '<tr id="' + c.ticketnumber + '">' +
          '<td align="center"></td>'
      }
      else {
        let severity = c.dpa_caseseverityidname.toLowerCase()
        if (severity == "high") {
          priority = "3"
        }
        else if (severity == "medium") {
          priority = "2"
        }
        else if (severity == "low") {
          priority = "1"
        }

        tr += '<tr id="' + c.ticketnumber + '">' +
          '<td align="center" data-sort="' + priority + '">' +
          '<span class="dot ' + severity + '"></span>' +
          '</td>'
      }

      tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
        '<td>' + c.dpa_casesubtypeidname + '</td>' +
        '<td>' + c.customeridname + '</td>' +
        '<td>' + c.dpa_casechannelidname + '</td>' +
        '<td>' + c.dpa_casestatusidname + '</td>' +
        '<td><span class="sr-only">' + this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' + 
        this.util.transformDate(c.createdon, 'shortWithTime') + '</td>'
      if (c.dpa_issla) {
        tr += '<td align="center" class="high">Over</td>'
      }
      else {
        if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
          tr += '<td align="center" class="low">Warning</td>'
        }
        else {
          tr += '<td align="center" class="high"></td>'
        }
      }
      tr += '<td><span class="sr-only">' + this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>' 
      + this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
        '</tr>'
      $("#tbFollowCase tbody").append(tr);
    });

    this.initTableFollow()
  }
}



// WEBPACK FOOTER //
// ./src/app/case/case.component.ts